import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { connect } from 'react-redux';
import { mapStateToProps } from '../models/buscar';
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function createData(name, cargo) {
  return { name, cargo };
}


function CustomizedTables(props) {
  const rows = [
    createData('Usuario', props.token.name),
    createData('Cargo', props.token.level),
  ];
  return (
    <TableContainer component={Paper}>
      <Table sx={{ maxWidth: '100%'  }} aria-label="customized table">
        <TableHead>
          <TableRow >
            <StyledTableCell style={{backgroundColor: 'lightgrey', color: '#000', fontWeight: 600}}>Información del Reporte</StyledTableCell>
            <StyledTableCell style={{backgroundColor: 'lightgrey', color: '#000'}} align="right"></StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <StyledTableRow key={row.name}>
              <StyledTableCell component="th" scope="row">
                {row.name}
              </StyledTableCell>
              <StyledTableCell align="right">{row.cargo}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default connect(mapStateToProps, null)(CustomizedTables);
